
import { GET_LIGHTNING } from '../actions/lightningActions';

const initialState = {
    fetchingLightning: false
};

export function lightning(state = initialState, action) {
    switch (action.type) {
        case GET_LIGHTNING.pending:
        {
            return {
                ...state,
                lightning: undefined,
                fetchingLightning: true
            };
        }
        case GET_LIGHTNING.fulfilled:
        {
            return {
                ...state,
                lightning: action.payload,
                lastError: {},
                fetchingLightning: false
            };
        }
        case GET_LIGHTNING.rejected:
        {
            return{
                ...state,
                lightning: undefined,
                lastError: action.payload,
                fetchingLightning: false
            };
        }
        default:
        {
            return state;
        }
    }
}
